export default {
    doctor: {
        "en": "Customer",
        // "ar": 'زبون تجزئة',
        "ar": "زبون",
    },
    doctorVisits: {
        "en": "Customer visits",
        // "ar": "زيارات زبون التجزئة"
        "ar": "زيارات الزبون"
    },
    doctors: {
        "en": "Customers",
        // "ar": "زبائن التجزئة"
        "ar": "زبائن"
    },
    pharmacy: {
        "en": "Customer",
        // "ar": "زبون الجملة"
        "ar": "زبون"
    },
    pharmacies: {
        "en": "Customers",
        // "ar": "زبائن الجملة"
        "ar": "زبائن"
    },
    center: {
        "en": "Center",
        "ar": "المركز"
    },
    centers: {
        "en": "Centers",
        "ar": "المراكز "
    },
    pharmacyVisits: {
        "en": " visits",
        // "ar": "زيارات زبون الجملة"
        "ar": "زيارات "
    },
    centerVisits: {
        "en": "Center visits",
        "ar": "زيارات المراكز "
    },
    medicalRep: {
        "en": "Medical rep",
        "ar": "مندوبين"
    },
    
    doctorName: {
        "en": "Customer name",
        "ar": "اسم الزبون "
    },
    doctorHobbies: {
        "en": "Customer hobbies",
        "ar": "عادات الزبون "
        // "ar": "عادات العميل"
    },
    editDoctor: {
        "en": "Edit customer",
        "ar": "تعديل زبون"
    },

    deleteDoctor: {
        "en": "Delete customer",
        "ar": "حذف زبون"
    },
    centerNotes: {
        "en": "Center notes",
        "ar": "ملاحظات مراكز"
    },

    pharmaceuticalForms: {
        "en": "Pharmaceutical forms",
        "ar": "الأشكال الدوائية"
    },

    pillsPerBox: {
        "en": "Pills per box",
        "ar": 'عدد القطع في الصندوق',
    },

    medRepPlan: {
        "en": "medical.Rep plan",
        "ar": "خطة مندوب"
    },

    medRepZone: {
        "en": "medical.Rep zone",
        "ar": "قسم المندوب "
    },

    medRepMark: {
        "en": "Medical.Rep mark",
        "ar": "تقييم المندوب "
    },

    addNewDoctor: {
        "en": "Add new customer",
        "ar": "إضافة زبون جديد"
    },

    specialty: {
        "en": "specialty",
        "ar": "تخصص الزبون"
    },

    specialties: {
        "en": "Specialties",
        "ar": "تخصصات الزبائن"
    },

    // samples
    supervisorRemainingSamples: {
        "en": "Remaining Samples",
        "ar": "المواد المتبقية"
    },

    samplesStatement: {
        "en": "Samples statement",
        "ar": "كشف مواد",
    },

    DeliverItems: {
        "en": "Deliver items",
        "ar": "تسليم مواد"
    },

    addPharmaceuticalForm: {
        "en": "Add pharmaceutical form",
        "ar": 'إضافة شكل دوائي'
    },

    editPharmaceuticalForm: {
        "ar": 'تعديل شكل دوائي',
        "en": "Edit pharmaceutical form"
    },

    thePharmaceuticalForm: {
        "ar": 'الشكل الدوائي؟',
        "en": "the pharmaceutical form?"
    },

    pharmaceuticalForm: {
        "en": "Pharmaceutical forms",
        "ar": "الشكل الدوائي"
    },

    "medicalRepPlan": {
        "en": "Rep plan",
        "ar": "خطة المندوب"
    },
    "medicalVisits": {
        "en": "Rep visits",
        "ar": "زيارات مندوب"
    },
    "MedicalReps": {
        "en": "Rep",
        "ar": "مندوبين طبين"
    },
    "preCallAnalysis": {
        "en": "pre call analysis",
        "ar": "تقييم الزيارة"
    },
    "call": {
        "en": "Call",
        "ar": "تقييم الزيارة"
    },
    "pharmacistInfo": {
        "en": "Customer info",
        "ar": "معلومات عن الزبون"
    }

}